import PersonIcon from "@mui/icons-material/Person";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import BarChartIcon from "@mui/icons-material/BarChart";
import EmailIcon from "@mui/icons-material/Email";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import PeopleIcon from "@mui/icons-material/People";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AssignmentIcon from "@mui/icons-material/Assignment";
import WorkspacePremium from "@mui/icons-material/WorkspacePremium";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import HomeIcon from '@mui/icons-material/Home';
import Logout from "@mui/icons-material/Logout";
import DescriptionIcon from "@mui/icons-material/Description";
import { iconButtonClasses } from "@mui/material";
import { Edit, Login } from "@mui/icons-material";
import BusinessIcon from '@mui/icons-material/Business';
import SecurityIcon from '@mui/icons-material/Security';
import TrendingUp from '@mui/icons-material/TrendingUp';
import ListIcon from '@mui/icons-material/List';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import MemoryIcon from '@mui/icons-material/Memory';
import DatasetIcon from '@mui/icons-material/Dataset';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import LinkIcon from '@mui/icons-material/Link';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import {
  MessageSquare,
  LayoutDashboard,
  Users,
  ClipboardList,
  LayoutGrid,
  GitBranch,
  MailCheck,
  Building2,
  Send,
  Images,
  Briefcase,
  Mails,
  SlidersHorizontal,
  FileSpreadsheet,
} from 'lucide-react';
const routeConfig = [
  {
    path: "/candidate/home",
    component: "CandidateHome",
    roles: ["admin", "recruiter", "guide", "candidate", "client"],
    key: "CandidateHome",
    menu: {
      name: "Home",
      path: "/",
      key: "candidate-home",
      icon: HomeIcon,
    },
  },
  {
    path: "/candidate/applications",
    component: "CandidateApplicationsPage",
    roles: ["admin", "recruiter", "guide", "candidate", "client"],
    key: "CandidateApplicationsPage",
    menu: null,
  },
  // Alias route for Target Companies, accessible via /Newexecedge
  {
    path: "/NewExecedge",
    component: "TargetCompaniesPage",
    roles: ["admin", "recruiter", "guide", "candidate", "client"],
    key: "NewExecedge",
    menu: null,
  },
  {
    path: "/NewExecedge/*",
    component: "TargetCompaniesPage",
    roles: ["admin", "recruiter", "guide", "candidate", "client"],
    key: "NewExecedgeView",
    menu: null,
  },
  {
    path: "/NewExecedge/resources/:fileName",
    component: "TargetCompaniesPage",
    roles: ["admin", "recruiter", "guide", "candidate", "client"],
    key: "NewExecedgeResourceShare",
    menu: null,
  },
  {
    path: "/NewExecedge/interview-brief-request",
    component: "ExecedgeNewInterviewBriefEntry",
    roles: ["admin", "recruiter", "guide", "candidate", "client"],
    key: "NewExecedgeInterviewBriefRequest",
    menu: null,
  },
  {
    path: "/interview-brief-request",
    component: "ExecedgeInterviewBriefRedirect",
    roles: ["admin", "recruiter", "guide", "candidate", "client"],
    key: "InterviewBriefRequestRedirect",
    menu: null,
  },
  {
    path: "/execedge/interview-brief-request",
    component: "ExecedgeLegacyInterviewBriefEntry",
    roles: ["admin", "recruiter", "guide", "candidate", "client"],
    key: "ExecedgeInterviewBriefRequest",
    menu: null,
  },
  {
    path: "/execedge/interview-briefs",
    component: "InterviewBriefDashboard",
    roles: ["admin", "recruiter"],
    key: "ExecedgeInterviewBriefDashboard",
    menu: null,
  },
  {
    path: "/execedge/compensation-briefs",
    component: "CompensationBriefDashboard",
    roles: ["admin", "recruiter"],
    key: "ExecedgeCompensationBriefDashboard",
    menu: null,
  },
  {
    path: "/execedge/client-ops",
    component: "ExecEdgeClientOpsHub",
    roles: ["admin", "recruiter", "guide"],
    key: "ExecedgeClientOpsHub",
    menu: null,
  },
  {
    path: "/execedge/dashboard",
    component: "ExecEdgeDashboardTable",
    roles: ["admin", "recruiter", "guide"],
    key: "ExecEdgeDashboardTable",
    menu: null,
  },
  {
    path: "/execedge-funnel",
    component: "ExecEdgeFunnel",
    roles: ["admin"],
    key: "ExecEdgeFunnel",
    menu: null,
  },
  // Alias paths for dropdown-friendly nested routes
  {
    path: "/execedge/funnel",
    component: "ExecEdgeFunnel",
    roles: ["admin"],
    key: "ExecEdgeFunnelNested",
    menu: null,
  },
  // menu: {
  //   name: "Tracker",
  //   path: "/Pipeline",
  //   key: "candidate-pipeline",
  //   icon: BarChartIcon,
  // },
  {
    path: "/Tracker",
    component: "Associations",
    roles: ["admin", "recruiter"],
    key: "Pipeline",
    menu: null,
  },
  {
    path: "/hv",
    component: "",
    key: "hv",
    roles: ["admin", "recruiter"],
    menu: {
      name: "HV",
      path: "/",
      key: "hv",
//      icon: () => <img src="/logo192.png" alt="HV Logo" style={{ width: '25px', height: '25px', filter: 'brightness(0) invert(1)' }} />,
    },
    children: [
      {
        path: "/tracker",
        component: "Associations",
        roles: ["admin", "recruiter"],
        key: "hv-tracker",
        menu: {
          name: "Tracker",
          path: "/hv/tracker",
          key: "hv-tracker",
          icon: BarChartIcon,
        },
      },
      {
        path: "/roles",
        component: "RoleSanitize",
        roles: ["admin", "recruiter"],
        key: "hv-roles",
        menu: {
          name: "Roles",
          path: "/hv/roles",
          key: "hv-roles",
          icon: SecurityIcon,
        },
      },
      {
        path: "/sheet",
        component: "HireVedaSheet",
        roles: ["admin", "recruiter"],
        key: "hv-sheet",
        menu: {
          name: "HireVeda Sheet",
          path: "/hv/sheet",
          key: "hv-sheet",
          icon: LayoutGrid,
        },
      },
      {
        path: "/candidates",
        component: "ClientDashboard",
        roles: ["recruiter", "admin"],
        key: "hv-search",
        menu: {
          name: "Search",
          path: "/hv/candidates",
          key: "hv-search",
          icon: AssignmentIcon,
        },
      },
      {
        path: "/candidates/typesense",      
        component: "TypesenseCandidateSearch",
        roles: ["recruiter", "admin"],
        key: "hv-TSsearch",
        menu :{
          name: "Type Search", 
          key: "hv-ts-search",        
          icon: AssignmentIcon,
        }
      },
      {
        path: "/candidates/opensearch",
        component: "OpenSearchCandidateSearch",
        roles: ["recruiter", "admin"],
        key: "hv-opensearch",
        menu: {
          name: "Open Search",
          path: "/hv/candidates/opensearch",
          key: "hv-opensearch",
          icon: AssignmentIcon,
        },
      },
      {
        path: "/search",
        component: "SearchPage",
        roles: ["recruiter", "admin"],
        key: "hv-ai-search",
        menu: {
          name: "AI Search",
          path: "/hv/search",
          key: "hv-ai-search",
          icon: WorkOutlineIcon,
        },
      },
      {
        path: "/crustdata",
        component: "CrustdataSearch",
        roles: ["admin", "recruiter"],
        key: "hv-crustdata",
        menu: {
          name: "Crustdata",
          path: "/hv/crustdata",
          key: "hv-crustdata",
          icon: TravelExploreIcon,
        },
      },
      {
        path: "/signals",
        component: "SignalsDashboard",
        roles: ["admin", "recruiter"],
        key: "hv-signals",
        menu: {
          name: "Signals",
          path: "/hv/signals",
          key: "hv-signals",
          icon: TravelExploreIcon,
        },
      },
      {
        path: "/crm",
        component: "CRMCompanies",
        roles: ["admin", "recruiter"],
        key: "hv-crm",
        menu: {
          name: "Sales CRM",
          path: "/hv/crm",
          key: "hv-crm",
          icon: BusinessIcon,
        },
      },
      {
        path: "/crm/companies",
        component: "CRMCompanies",
        roles: ["admin", "recruiter"],
        key: "hv-crm-companies",
        menu: null,
      },
      {
        path: "/crm/companies/new",
        component: "CRMCompanies",
        roles: ["admin", "recruiter"],
        key: "hv-crm-new-company",
        menu: null,
      },
      {
        path: "/crm/companies/:organizationId/edit",
        component: "CRMCompanies",
        roles: ["admin", "recruiter"],
        key: "hv-crm-edit-company",
        menu: null,
      },
      {
        path: "/crm/companies/:organizationId",
        component: "CRMCompanies",
        roles: ["admin", "recruiter"],
        key: "hv-crm-company-details",
        menu: null,
      },
      {
        path: "/role-pipeline-report",
        component: "RolePipelineReport",
        roles: ["admin"],
        key: "hv-role-pipeline-report",
        menu: {
          name: "Role Pipeline Report",
          path: "/hv/role-pipeline-report",
          key: "hv-role-pipeline-report",
          icon: FileSpreadsheet,
        },
      },
    ],
  },
  {
    path: "/hv/jobs",
    component: "JobPage",
    key: "Jobs",
    roles: ["admin", "recruiter", "guide", "candidate", "guest"],
    menu: {
      name: "Jobs",
      path: "/hv/jobs",
      key: "jobs",
      icon: WorkOutlineIcon,
    },
  },
  {
    path: "/execedge",
    component: "ExecedgeEntryRedirect",
    roles: ["admin", "recruiter", "guide", "candidate"],
    key: "ExecEdge",
    menu: null,
  },
  // Alias path for dropdown-friendly nested route
  {
    path: "/execedge/main",
    component: "ExecedgeEntryRedirect",
    roles: ["admin", "recruiter", "guide", "candidate"],
    key: "ExecEdgeMainNested",
    menu: null,
  },
  // {
  //   path: "/resume-builder",
  //   component: "ResumeBuilder",
  //   roles: ["admin", "recruiter", "guide", "candidate"],
  //   key: "ResumeBuilder",
  //   menu: {
  //     name: "Resume Builder",
  //     path: "/resume-builder",
  //     key: "resume-builder",
  //     icon: DescriptionIcon,
  //   },
  // },
  {
    path: "/execedge",
    component: "",
    key: "execedge-menu",
    roles: ["admin", "recruiter", "guide", "candidate"],
    menu: {
      name: "ExecEdge",
      path: "/execedge",
      key: "execedge-menu",
      icon: WorkspacePremium,
    },
    children: [
      {
        path: "/",
        component: "ExecedgeEntryRedirect",
        roles: ["admin", "recruiter", "guide", "candidate"],
        key: "execedge-main",
        menu: {
          name: "Dashboard",
          path: "/execedge/",
          key: "execedge-main",
          icon: LayoutDashboard,
        },
      },
      {
        path: "/client-ops",
        component: "ExecEdgeClientOpsHub",
        roles: ["admin", "recruiter", "guide"],
        key: "execedge-client-ops",
        menu: {
          name: "Client Ops",
          path: "/execedge/client-ops",
          key: "execedge-client-ops",
          icon: LayoutGrid,
        },
      },
      {
        path: "/dashboard",
        component: "ExecEdgeDashboardTable",
        roles: ["admin", "recruiter", "guide"],
        key: "execedge-dashboard",
        menu: null,
      },
      {
        path: "/tracker-candidates",
        component: "ExecEdgeTrackerCandidatesDashboard",
        roles: ["admin", "recruiter"],
        key: "execedge-tracker-candidates",
        menu: {
          name: "Tracker Candidates",
          path: "/execedge/tracker-candidates",
          key: "execedge-tracker-candidates",
          icon: ClipboardList,
        },
      },
      {
        path: "/pipeline-report",
        component: "ExecEdgePipelineReport",
        roles: ["admin"],
        key: "execedge-pipeline-report",
        menu: {
          name: "ExecEdge Pipeline Report",
          path: "/execedge/pipeline-report",
          key: "execedge-pipeline-report",
          icon: FileSpreadsheet,
        },
      },
      {
        path: "/interview-briefs",
        component: "InterviewBriefDashboard",
        roles: ["admin", "recruiter"],
        key: "execedge-interview-briefs",
        menu: null,
      },
      {
        path: "/compensation-briefs",
        component: "CompensationBriefDashboard",
        roles: ["admin", "recruiter"],
        key: "execedge-compensation-briefs",
        menu: null,
      },
      {
        path: "/funnel",
        component: "ExecEdgeFunnel",
        roles: ["admin"],
        key: "execedge-funnel",
        menu: {
          name: "Sales Funnel",
          path: "/execedge-funnel",
          key: "execedge-funnel",
          icon: GitBranch,
        },
      },
      {
        path: "/emailverify",
        component: "EmailValidationDashboard",
        roles: ["admin", "recruiter"],
        key: "execedge-emailverify",
        menu: {
          name: "Email Validation",
          path: "/execedge/emailverify",
          key: "email-verify",
          icon: MailCheck,
        },
      },
      {
        path: "/company-emails",
        component: "CompanyEmailsDashboard",
        roles: ["admin", "recruiter"],
        key: "execedge-company-emails",
        menu: {
          name: "Company Emails",
          path: "/execedge/company-emails",
          key: "execedge-company-emails",
          icon: Building2,
        },
      },
      {
        path: "/uploader",
        component: "ExecEdgeUploader",
        roles: ["admin", "recruiter"],
        key: "execedge-uploader",
        menu: {
          name: "Uploader",
          path: "/execedge/uploader",
          key: "execedge-uploader",
          icon: FileSpreadsheet,
        },
      },
      {
        path: "/uploader/:sheet",
        component: "ExecEdgeUploader",
        roles: ["admin", "recruiter"],
        key: "execedge-uploader-sheet",
        menu: null,
      },
      {
        path: "/company-uploader",
        component: "ExecEdgeUploader",
        roles: ["admin", "recruiter"],
        key: "execedge-company-uploader",
        menu: null,
      },
      {
        path: "/dms-uploader",
        component: "ExecEdgeUploader",
        roles: ["admin", "recruiter"],
        key: "execedge-dms-uploader",
        menu: null,
      },
      {
        path: "/outreach-email-monitor",
        component: "ExecEdgeOutreachEmailMonitor",
        roles: ["admin"],
        key: "execedge-outreach-email-monitor",
        menu: {
          name: "Outreach Emails",
          path: "/execedge/outreach-email-monitor",
          key: "execedge-outreach-email-monitor",
          icon: Send,
        },
      },
      
      {
        path: "/snapshots",
        component: "SnapshotsList",
        roles: ["admin"],
        key: "execedge-snapshots-list",
        // menu: {
        //   name: "All Snapshots",
        //   path: "/execedge/snapshots",
        //   key: "execedge-snapshots-list",
        //   icon: Images,
        // },
      },
      {
        path: "/feedback-forms",
        component: "FeedbackSubmissionsDashboard",
        roles: ["admin", "recruiter"],
        key: "execedge-feedback-forms",
        menu: null,
      },
      {
        path: "/all-jobs",
        component: "AllJobsPage",
        roles: ["admin", "recruiter"],
        key: "execedge-all-jobs",
        menu: {
          name: "All Jobs",
          path: "/execedge/all-jobs",
          key: "execedge-all-jobs",
          icon: Briefcase,
        },
      },

    ],
  },
  {
    path: "/Candidates",
    component: "ClientDashboard",
    roles: ["recruiter", "admin"],
    key: "Candidates",
    menu: null,
  },
  {
    path: "/edit-profile",
    component: "EditProfile",
    roles: ["admin", "candidate", "client", "recruiter", "guide"],
    menu: null,
  },
  {
    path: "/recover-password",
    component: "RecoverPassword",
    key: "RecoverPassword",
    roles: ["guest"],
    menu: null,
  },
  {
    path: "/login",
    component: "Login",
    key: "Login",
    roles: ["guest"],
    menu: {
      name: "Login",
      path: "/login",
      key: "Login",
      icon: Login,
    },
  },

  {
    path: "/oauth-callback",
    component: "OAuthCallback",
    key: "OAuthCallback",
    roles: ["guest", "admin", "candidate", "client", "recruiter", "guide"],
    menu: null,
  },
  {
    path: "/",
    component: "Home",
    key: "Home",
    roles: ["admin", "candidate", "client", "recruiter", "guide"],
    menu: null,
  },
  {
    path: "/apply",
    component: "apply",
    key: "Apply",
    roles: ["guest", "admin", "candidate", "client", "recruiter", "guide"],
    menu: null,
  },
  {
    path: "/edit/:id",
    component: "EditCandidates",
    key: "EditCandidates",
    roles: ["candidate", "admin"],
    menu: null,
  },
  {
    path: "/admin",
    component: "",
    key: "admin",
    roles: ["admin"],
    menu: {
      name: "Admin",
      path: "/",
      key: "admin",
      icon: AdminPanelSettingsIcon,
    },
    children: [
      {
        path: "/dashboard",
        component: "AdminDashboard",
        key: "admin-dashboard",
        roles: ["admin"],
        menu: {
          name: "Dashboard",
          path: "/admin/dashboard",
          key: "admin-dashboard",
          icon: DashboardIcon,
        },
      },
      {
        path: "/execedge-dashboard",
        component: "OutreachTrackerPage",
        key: "admin-execedge-dashboard",
        roles: ["admin"],
        menu: {
          name: "ExecEdge Dashboard",
          path: "/admin/execedge-dashboard",
          key: "admin-execedge-dashboard",
          icon: LayoutDashboard,
        },
      },
      {
        path: "/execedge-clients",
        component: "ExecEdgeClientsOpsPage",
        key: "admin-execedge-clients",
        roles: ["admin"],
        menu: {
          name: "ExecEdge Clients",
          path: "/admin/execedge-clients",
          key: "admin-execedge-clients",
          icon: Users,
        },
      },
      {
        path: "/tracking",
        component: "TrackingDashboard",
        key: "admin-tracking",
        roles: ["admin"],
        menu: {
          name: "Traffic",
          path: "/admin/tracking",
          key: "admin-tracking",
          icon: TrendingUp,
        },
      },
      {
        path: "/apply-page",
        component: "ApplyPageApplicationsDashboard",
        key: "admin-apply-page",
        roles: ["admin"],
        menu: {
          name: "Apply Page",
          path: "/admin/apply-page",
          key: "admin-apply-page",
          icon: AssignmentIcon,
        },
      },
      {
        path: "/automate-emails",
        component: "AutomateEmailsDashboard",
        key: "admin-automate-emails",
        roles: ["admin"],
        menu: {
          name: "Automate Emails",
          path: "/admin/automate-emails",
          key: "admin-automate-emails",
          icon: Mails,
        },
      },
      {
        path: "/error-monitor",
        component: "ErrorEventsDashboard",
        key: "admin-error-monitor",
        roles: ["admin"],
        menu: {
          name: "Error Monitor",
          path: "/admin/error-monitor",
          key: "admin-error-monitor",
          icon: ReportProblemIcon,
        },
      },
      {
        path: "/short-links",
        component: "ShortLinksDashboard",
        key: "admin-short-links",
        roles: ["admin"],
        menu: {
          name: "Short Links",
          path: "/admin/short-links",
          key: "admin-short-links",
          icon: LinkIcon,
        },
      },
      {
        path: "/privacy",
        component: "AdminPrivacyPage",
        key: "admin-privacy",
        roles: ["admin"],
        menu: {
          name: "Privacy",
          path: "/admin/privacy",
          key: "admin-privacy",
          icon: SecurityIcon,
        },
      },
  {
    path: "/whatsapp/dashboard",
    component: "",
    roles: ["admin"],
    key: "whatsapp-dashboard-menu",
    menu: {
      name: "WhatsApp",
      path: "/whatsapp/dashboard",
      key: "whatsapp-dashboard-menu",
      icon: MessageSquare,
    },
  },
      // {
      //   path: "/upload",
      //   component: "FileUploadComponent",
      //   roles: ["admin"],
      //   key: "admin-upload",
      //   menu: {
      //     name: "Import",
      //     path: "/admin/upload",
      //     key: "admin-upload",
      //     icon: ImportExportIcon,
      //   },
      // },
      {
        path: "/users",
        component: "AdminUserManagement",
        roles: ["admin"],
        key: "admin-users",
        menu: {
          name: "Users",
          path: "/admin/users",
          key: "admin-users",
          icon: PeopleIcon,
        },
      },
      {
        path: "/normalization",
        component: "NormalizationDashboard",
        roles: ["admin"],
        key: "admin-normalization",
      },
      {
        path: "/master-data",
        component: "MasterDataDashboard",
        roles: ["admin"],
        key: "admin-master-data",
        menu: {
          name: "Master Data",
          path: "/admin/master-data",
          key: "admin-master-data",
          icon: DatasetIcon,
        },
      },
      {
        path: "/candidate-corrections",
        component: "CandidateCorrectionDashboard",
        roles: ["admin"],
        key: "admin-candidate-corrections",
      },
      {
        path: "/typesense-health",
        component: "TypesenseDashboard",
        roles: ["admin"],
        key: "admin-typesense-health",
        menu: {
          name: "Typesense Health",
          path: "/admin/typesense-health",
          key: "admin-typesense-health",
          icon: MonitorHeartIcon,
        },
      },
      {
        path: "/ec2",
        component: "Ec2MonitoringPage",
        roles: ["admin"],
        key: "admin-ec2",
        menu: {
          name: "EC2 Monitoring",
          path: "/admin/ec2",
          key: "admin-ec2",
          icon: MemoryIcon,
        },
      },
      {
        path: "/workers",
        component: "WorkersDashboard",
        key: "admin-workers",
        roles: ["admin"],
        menu: {
          name: "Worker Fleet",
          path: "/admin/workers",
          key: "admin-workers",
          icon: BarChartIcon,
        },
      },
      {
        path: "/workers/:id",
        component: "WorkerDetail",
        key: "admin-worker-detail",
        roles: ["admin"],
      },
      {
        path: "/candidates/:id",
        component: "CandidateEditPage",
        key: "admin-candidate-edit",
        roles: ["admin"],
      },
      {
        path: "/masters",
        component: "MastersBrowser",
        roles: ["admin"],
        key: "admin-masters",
        menu: {
          name: "Masters",
          path: "/admin/masters/institution",
          key: "admin-masters",
          icon: AccountTreeIcon,
        },
      },
      {
        path: "/masters/:type",
        component: "MastersBrowser",
        roles: ["admin"],
        key: "admin-masters-type",
      },
      // {
      //   path: "/linkedin",
      //   component: "linkedintab",
      //   roles: ["admin"],
      //   key: "admin-linkedin",
      //   menu: {
      //     name: "LinkedIn",
      //     path: "/admin/linkedin",
      //     key: "admin-linkedin",
      //     icon: LinkedInIcon,
      //   },
      // },
      // {
      //   path: "/BulkMerge",
      //   component: "BulkUpdateComponent",
      //   roles: ["admin"],
      //   menu: null,
      // },
      // {
      //   path: "/Roles",
      //   component: "RoleManagement",
      //   roles: ["admin"],
      //   key: "admin-roles",
      //   menu: {
      //     name: "Roles",
      //     path: "/admin/Roles",
      //     key: "admin-roles",
      //     icon: AccountTreeIcon,
      //   },
      // },
      // {
      //   path: "/Admin/Email",
      //   component: "EmailReaderDashboard",
      //   roles: ["admin"],
      //   key: "admin-email",
      //   menu: {
      //     name: "Email Reader",
      //     path: "/admin/Email",
      //     key: "admin-email",
      //     icon: EmailIcon,
      //   },
      // },
      {
        path: "/jobs",
        component: "JobsDashboard",
        roles: ["admin"],
        key: "admin-jobs",
        menu: {
          name: "Jobs",
          path: "/admin/jobs",
          key: "admin-jobs",
          icon: WorkOutlineIcon,
        },
      },
      {
        path: "/Statuses",
        component: "AdminStatusManager",
        roles: ["admin"],
        key: "admin-statuses",
        menu: {
          name: "Statuses",
          path: "/admin/Statuses",
          key: "admin-statuses",
          icon: AssignmentIcon,
        },
      },
      {
        path: "/role-search",
        component: "RoleSearchLab",
        roles: ["admin"],
        key: "admin-role-search",
        menu: {
          name: "Role Search Lab",
          path: "/admin/role-search",
          key: "admin-role-search",
          icon: SlidersHorizontal,
        },
      },
      {
        path: "/company/home",
        component: "CompanyHome",
        roles: ["admin", "recruiter"],
        key: "CompanyHome",
        menu: {
          name: "Company",
          path: "/admin/company/home",
          key: "company-home",
          icon: BusinessIcon,
        },
      },
      {
        path: "/company/people",
        component: "CompanyPeoplePage",
        roles: ["admin", "recruiter"],
        key: "CompanyPeoplePage",
        menu: {
          name: "People",
          path: "/admin/company/people",
          key: "company-people",
          icon: PeopleIcon,
        },
      },
      // {
      //   path: "/email",
      //   component: "EmailCampaignDashboard",
      //   key:"EmailCampaignDashboard",
      //   roles: ["admin"],
      //   menu: {
      //     name: "Email Campaign",
      //     path: "/email",
      //     key: "email-campaign",
      //     icon: EmailIcon,
      //   },
      // },

    ],
  },
  {
    path: "/fin360",
    component: "CandidateForm",
    key: "CandidateForm",
    roles: ["admin", "candidate"],
  },
  {
    path: "/emailverify",
    component: "EmailValidationDashboard",
    key: "EmailValidationDashboard",
    roles: ["admin", "recruiter"],
    menu: null,
  },
  {
    path: "/execedge/emailverify",
    component: "EmailValidationDashboard",
    key: "EmailValidationDashboardNested",
    roles: ["admin", "recruiter"],
    menu: null,
  },
  {
    path: "/execedge/company-emails",
    component: "CompanyEmailsDashboard",
    key: "CompanyEmailsDashboard",
    roles: ["admin", "recruiter"],
    menu: null,
  },
  {
    path: "/execedge/uploader",
    component: "ExecEdgeUploader",
    key: "ExecEdgeUploader",
    roles: ["admin", "recruiter"],
    menu: null,
  },
  {
    path: "/execedge/uploader/:sheet",
    component: "ExecEdgeUploader",
    key: "ExecEdgeUploaderSheet",
    roles: ["admin", "recruiter"],
    menu: null,
  },
  {
    path: "/execedge/company-uploader",
    component: "ExecEdgeUploader",
    key: "CompanyUploaderSheet",
    roles: ["admin", "recruiter"],
    menu: null,
  },
  {
    path: "/execedge/dms-uploader",
    component: "ExecEdgeUploader",
    key: "DmsUploaderSheet",
    roles: ["admin", "recruiter"],
    menu: null,
  },
  {
    path: "/execedge/all-jobs",
    component: "AllJobsPage",
    key: "AllJobsPage",
    roles: ["admin", "recruiter"],
    menu: null,
  },
  {
    path: "/execedge/outreach-email-monitor",
    component: "ExecEdgeOutreachEmailMonitor",
    key: "ExecEdgeOutreachEmailMonitorNested",
    roles: ["admin"],
    menu: null,
  },
  {
    path: "/execedge/pipeline-report",
    component: "ExecEdgePipelineReport",
    key: "ExecEdgePipelineReportPage",
    roles: ["admin"],
    menu: null,
  },
  {
    path: "/admin/outreach-email-monitor",
    component: "ExecEdgeOutreachEmailMonitor",
    key: "ExecEdgeOutreachEmailMonitorAdminAlias",
    roles: ["admin"],
    menu: null,
  },
  // Role Sanitize - only accessible to logged-in users
  // menu: {
  //   name: "Roles",
  //   path: "/role-sanitize",
  //   key: "role-sanitize",
  //   icon: SecurityIcon,
  // },
  {
    path: "/role-sanitize",
    component: "RoleSanitize",
    key: "role-sanitize",
    roles: ["admin", "recruiter"],
    menu: null,
  },

  {
    path: "/candidate",
    component: "",
    key: "candidate",
    roles: ["candidate", "admin", "recruiter"],
    // menu: {
    //   name: "Dashboard",
    //   path: "/candidate",
    //   key: "candidate",
    //   icon: DashboardIcon,
    // },
    children: [
      {
        path: "/profile",
        key: "candidate-profile",
        component: "CandidateDashboardMain",
        roles: ["candidate", "admin", "recruiter"],
        icon: PersonIcon,
        // menu: {
        //   name: "Profile",
        //   key: "Edit-Profile",
        //   icon: Edit
        // } 
      }
    ]
  },
  {
    path: "/settings/privacy",
    component: "PrivacyDashboard",
    key: "privacy-settings",
    roles: ["candidate", "admin", "recruiter", "guide"],
    menu: null,
  },
  {
    path: "/settings/privacy/account/:action",
    component: "AccountDataPage",
    key: "privacy-account-data",
    roles: ["candidate", "admin", "recruiter", "guide"],
    menu: null,
  },
  {
    path: "/legal/accept",
    component: "LegalAcceptPage",
    key: "legal-accept",
    roles: ["candidate", "admin", "recruiter", "guide"],
    menu: null,
  },
  {
    path: "/legal/documents/:documentKey",
    component: "LegalDocumentPage",
    key: "legal-document",
    roles: ["guest", "candidate", "admin", "recruiter", "guide"],
    menu: null,
  },
  // {
  //   path: "/candidate-dashboard",
  //   component: "CandidateDashboardMain",
  //   roles: ["candidate", "admin"],
  //   key: "CandidateDashboardMain",
  //   menu: {
  //     name: "Candidate Dashboard (New)",
  //     path: "/candidate-dashboard",
  //     key: "candidate-dashboard-main",
  //     icon: DashboardIcon,
  //   },
  // },
  // {
  //   path: "/candidate-dashboard-v2",
  //   component: "CandidateDashboard",
  //   roles: ["candidate", "admin"],
  //   key: "CandidateDashboardV2",
  //   menu: {
  //     name: "Candidate Dashboard V2",
  //     path: "/candidate-dashboard-v2",
  //     key: "candidate-dashboard-v2",
  //     icon: DashboardIcon,
  //   },
  // },
  // {
  //   path: "/new-candidate-form",
  //   component: "NewCandidateForm",
  //   roles: ["candidate", "admin"],
  //   key: "NewCandidateForm",
  //   menu: {
  //     name: "New Candidate Form",
  //     path: "/new-candidate-form",
  //     key: "new-candidate-form",
  //     icon: PersonIcon,
  //   },
  // },
  // {
  //   path: "/association-websocket",
  //   component: "AssociationWebSocket",
  //   roles: ["admin", "recruiter"],
  //   key: "AssociationWebSocket",
  //   menu: {
  //     name: "Association (WebSocket)",
  //     path: "/association-websocket",
  //     key: "association-websocket",
  //     icon: BarChartIcon,
  //   },
  // },
];

export default routeConfig;
